<script lang="ts">
	//UI
	import AppLayout from "../v7/layout/AppLayout.svelte";
	//Utils
	//Types
	//Props
	//Constants
	//Variables
	//Functions
	//Do

</script>

<AppLayout>
	<div slot="header" class="header">
		<img src="/img/icons/MobileLogo.png" alt="Mobile Logo" />
	</div>
	<div class="body">
		<div class="circle"><img src="/icons/error.png" alt="" /></div>
		<p class="description">현재 만료된 페이지 입니다.</p>
	</div>
</AppLayout>

<style lang="scss">
	.header {
		display: flex;
		width: 100%;
		height: 100%;
		align-items: center;
		img {
			width: 36px;
			height: 22.9px;
		}
	}
	.body {
		width: 100%;
		box-sizing: border-box;
		justify-content: center;
		flex-direction: column;
		padding-top: 129px;
		display: flex;
		align-items: center;
		gap: 30px;
		.circle {
			width: 200px;
			height: 200px;
			background-color: white;
			border-radius: 200px;
			display: flex;
			align-items: center;
			justify-content: center;

			img {
				width: 100px;
				height: 100px;
			}
		}
		p.description {
			font-weight: 500;
			color: #46474b;
		}
	}

</style>
